<template>
  <div>
    <div class="title__success">
      <span class="span__success">Пополнение счета</span>
      <div class="items__success">
        <a class="link--success" href="/personal/account/prepaid.php">
          <span class="dotted">юридическое лицо</span>
        </a>
        <a class="link--success" href="/personal/account/prepaidfiz.php">
          <span class="dotted">физическое лицо</span>
        </a>
      </div>
    </div>
    <div>
      <div class="table__wrapper">

        <table>
          <thead>
          <tr>
            <th>№</th>
            <th>Дата</th>
            <th>Сумма</th>
            <th>Описание</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="transact of budgetHistory">
            <td>{{transact.ID}}</td>
            <td>{{transact.DATE}}</td>
            <td>
              {{transact.AMOUNT_FORMATTED}}
              <br/>
              <small>({{transact.DEBIT ? 'на счет' : 'со счета'}})</small>
            </td>
            <td>{{transact.DESCRIPTION}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'budget',
    computed: {
      ...mapGetters('user', [
        'budgetHistory'
      ])
    },
    created () {
      if (this.budgetHistory.length <= 0) {
        this.$store.dispatch('user/fetchBudgetHistory')
      }
    }

  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Personal/Budget.vue